import mergeWith from 'lodash/mergeWith'

import { useBuilder } from '@/lib/builder/extension/useBuilder'
import { reorder } from '@/utils/helpers'

import { type CardsSection } from '../../../WebsiteBuilder.types'

const websiteBuilderQueue = useBuilder('websiteBuilder')

const updateBlock = websiteBuilderQueue.createBlockCommand<CardsSection>({
  commit: async (currentData, ctx) => {
    return mergeWith(currentData, ctx.update, (_objValue, srcValue, key) => {
      if (key === 'cards') {
        return srcValue
      }
    })
  },
})

type Card = CardsSection['params']['cards'][number]

const BLANK: Card = {
  buttonLabel: null,
  description: null,
  image: null,
  link: null,
  subtitle: null,
  title: '',
}

const CardsCommands = {
  async createCard(current: CardsSection): Promise<number> {
    const cards = current.params.cards.concat([BLANK])

    await updateBlock({
      targetId: current.id,
      update: { params: { ...current.params, cards } },
    })

    return cards.length - 1
  },

  async deleteCard(current: CardsSection, cardIndex: number): Promise<void> {
    const cards = current.params.cards.filter((_, i) => i !== cardIndex)

    await updateBlock({
      targetId: current.id,
      update: { params: { ...current.params, cards } },
    })
  },

  async reorderCard(
    current: CardsSection,
    oldIndex: number,
    newIndex: number
  ): Promise<void> {
    const cards = reorder(current.params.cards, oldIndex, newIndex)

    await updateBlock({
      targetId: current.id,
      update: { params: { ...current.params, cards } },
    })
  },

  updateBlock,

  async updateCard(
    current: CardsSection,
    cardIndex: number,
    updatedCard: Card
  ): Promise<void> {
    const cards = current.params.cards.map((card, i) =>
      i === cardIndex ? updatedCard : card
    )

    await updateBlock({
      targetId: current.id,
      update: { params: { ...current.params, cards } },
    })
  },
}

export { CardsCommands }
